module.exports = __webpack_public_path__ + "static/img/TOP-copy.46887a2b.png";